// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Markets$Showside from "../types/Markets.bs.js";
import * as PDPForm$Showside from "../components/PDPForm.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as NavSdk from "@makerinc/nav-sdk";
import * as Category$Showside from "../types/Category.bs.js";
import * as SmartImg$Showside from "./SmartImg.bs.js";
import * as SmartNavVideo$Showside from "../components/SmartNavVideo.bs.js";
import * as CategoryFinder$Showside from "../types/CategoryFinder.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as SWRScrapeCache$Showside from "./SWRScrapeCache.bs.js";
import * as CustomComponentId$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/CustomComponentId.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
var Loader = {};
function transformProps(props) {
  var transformProp = function (value) {
    if (typeof value === "number") {
      return;
    } else {
      return Caml_option.some(value._0);
    }
  };
  return Js_dict.map(transformProp, props);
}
function transform(activeVariantId, product) {
  return {
    id: product.id,
    title: product.name,
    link: product.link,
    productType: product.productType,
    categoryId: product.categoryId,
    variants: Belt_Array.map(Product$Showside.getAllVariantsWithPriority(activeVariantId, product), function (variant) {
      return Product$Showside.toLegacyDTO(product, variant);
    }),
    metadata: product.metadata
  };
}
var External = {};
function NavSDK$ProductRenderer(Props) {
  var activeVariantId = Props.activeVariantId;
  var componentId = Props.componentId;
  var data = Props.data;
  var props = Props.props;
  var renderFallback = Props.renderFallback;
  var data$1 = React.useMemo(function () {
    return transform(activeVariantId, data);
  }, [Product$Showside.getKey(undefined, data)]);
  var props$1 = transformProps(props);
  return React.createElement(NavSdk.Renderer, {
    componentId: componentId,
    data: data$1,
    renderFallback: renderFallback,
    additionalProps: props$1
  });
}
NavSDK$ProductRenderer.displayName = "NavSDK.ProductRenderer";
var ProductRenderer = {
  transform: transform,
  External: External,
  make: NavSDK$ProductRenderer
};
var External$1 = {};
function NavSDK$CustomSectionRenderer(Props) {
  var componentId = Props.componentId;
  var renderFallback = Props.renderFallback;
  var props = Props.props;
  var props$1 = transformProps(props);
  return React.createElement(NavSdk.Renderer, {
    componentId: componentId,
    renderFallback: renderFallback,
    additionalProps: props$1
  });
}
NavSDK$CustomSectionRenderer.displayName = "NavSDK.CustomSectionRenderer";
var CustomSectionRenderer = {
  External: External$1,
  make: NavSDK$CustomSectionRenderer
};
function transform$1(category) {
  return {
    id: category.id,
    title: category.title,
    description: category.description,
    image: Category$Showside.getCategoryImage(category),
    imageWidth: Category$Showside.getCategoryImageSize(category)[0],
    imageHeight: Category$Showside.getCategoryImageSize(category)[1],
    video: Category$Showside.getCategoryVideo(category),
    children: Category$Showside.getChildren(category).map(transform$1)
  };
}
var External$2 = {};
function NavSDK$CategoryRenderer(Props) {
  var componentId = Props.componentId;
  var data = Props.data;
  var renderFallback = Props.renderFallback;
  var props = Props.props;
  var data$1 = React.useMemo(function () {
    return transform$1(data);
  }, [Category$Showside.getKey(data)]);
  var props$1 = transformProps(props);
  return React.createElement(NavSdk.Renderer, {
    componentId: componentId,
    data: data$1,
    renderFallback: renderFallback,
    additionalProps: props$1
  });
}
NavSDK$CategoryRenderer.displayName = "NavSDK.CategoryRenderer";
var CategoryRenderer = {
  transform: transform$1,
  External: External$2,
  make: NavSDK$CategoryRenderer
};
function defaultRenderImage(props) {
  var match = props.fit;
  return React.createElement(SmartImg$Showside.make, {
    src: props.src,
    fit: match === "contain" ? /* Contain */2 : match === "scale-down" ? /* ScaleDown */0 : /* Cover */1,
    alt: props.alt,
    priority: props.priority
  });
}
function defaultRenderVideo(props) {
  var match = props.fit;
  return React.createElement(SmartNavVideo$Showside.make, {
    src: props.src,
    poster: props.poster,
    objectFit: match === "contain" ? "contain" : match === "scale-down" ? "scale-down" : "cover",
    autoplay: props.autoplay,
    loop: props.loop,
    muted: props.muted,
    controls: props.controls
  });
}
function defaultProductLink(router, props) {
  return React.createElement("a", {
    style: {
      textDecoration: "none"
    },
    href: Belt_Option.getWithDefault(props.href, ""),
    onClick: function (e) {
      e.preventDefault();
      Curry._3(router.goTo, undefined, undefined, {
        TAG: /* PDP */2,
        _0: {
          categoryId: undefined,
          productCategoryId: props.categoryId,
          productId: props.productId,
          variantId: props.variantId,
          zoomedPhotoIndex: undefined
        }
      });
    }
  }, Belt_Option.getWithDefault(props.children, null));
}
function defaultCategoryLink(router, props) {
  return React.createElement("a", {
    style: {
      textDecoration: "none"
    },
    href: Belt_Option.getWithDefault(props.href, ""),
    onClick: function (e) {
      e.preventDefault();
      Curry._3(router.goTo, undefined, undefined, {
        TAG: /* ListPage */1,
        _0: {
          listPageType: {
            TAG: /* Category */0,
            _0: props.categoryId
          },
          viewPLP: false,
          filters: undefined,
          sort: undefined
        }
      });
    }
  }, Belt_Option.getWithDefault(props.children, null));
}
function defaultProductForm(props) {
  var match = EntrypointContext$Showside.use(undefined);
  var match$1 = Markets$Showside.getValues(match.market);
  var match$2 = ConfigurationProvider$Showside.use(undefined);
  var product = SWRScrapeCache$Showside.getProductById(match.smartnavApiHost, match$1.currency, match$1.country, props.product.id);
  var variant = Belt_Option.flatMap(Belt_Option.map(product, Product$Showside.getAllVariants), function (variants) {
    return Belt_Array.get(variants, 0);
  });
  if (product !== undefined && variant !== undefined) {
    return React.createElement(PDPForm$Showside.make, PDPForm$Showside.makeProps(product, variant, undefined, match$2.config.settings.hideOutOfStock, match.onProductFormChange, match.onProductFormSubmit, props.children, undefined, undefined));
  } else {
    return React.createElement("h1", undefined, "Product not found");
  }
}
function defaultProductVariantPicker(props) {
  return React.createElement(PDPForm$Showside.AllFields.make, {
    onRender: function (field, onChange, element) {
      return Curry._2(props.children, field, onChange);
    }
  });
}
function defaultProductQuantityPicker(props) {
  return React.createElement(PDPForm$Showside.QuantityPicker.make, {
    onRender: props.children
  });
}
function defaultProductBuyButton(props) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var tmp = {};
  if (props.className !== undefined) {
    tmp.className = Caml_option.valFromOption(props.className);
  }
  if (props.style !== undefined) {
    tmp.style = Caml_option.valFromOption(props.style);
  }
  return React.createElement(PDPForm$Showside.SubmitButton.make, {
    children: React.createElement("button", tmp, Curry._1(props.children, "available")),
    label: match.config.settings.pdpAddToCartLabel,
    submitButtonType: /* AddToCart */0
  });
}
function defaultProductInfo(props) {
  var match = PDPForm$Showside.use(undefined);
  var form = match.form;
  var match$1 = form.product;
  var match$2 = form.variant;
  var transformed = match$1 !== undefined && match$2 !== undefined ? Product$Showside.toLegacyDTO(match$1, match$2) : undefined;
  if (transformed !== undefined) {
    return Curry._1(props.children, transformed);
  } else {
    return null;
  }
}
var External$3 = {};
function NavSDK$SharedComponentsProvider(Props) {
  var children = Props.children;
  var router = RouterProvider$Showside.useRouter(undefined);
  return React.createElement(NavSdk.SharedComponentsProvider, {
    renderImage: defaultRenderImage,
    renderVideo: defaultRenderVideo,
    renderProductLink: function (param) {
      return defaultProductLink(router, param);
    },
    renderCategoryLink: function (param) {
      return defaultCategoryLink(router, param);
    },
    renderProductVariantPicker: defaultProductVariantPicker,
    renderProductForm: defaultProductForm,
    renderProductQuantityPicker: defaultProductQuantityPicker,
    renderProductBuyButton: defaultProductBuyButton,
    renderProductInfo: defaultProductInfo,
    children: children
  });
}
NavSDK$SharedComponentsProvider.displayName = "NavSDK.SharedComponentsProvider";
var SharedComponentsProvider = {
  defaultRenderImage: defaultRenderImage,
  defaultRenderVideo: defaultRenderVideo,
  defaultProductLink: defaultProductLink,
  defaultCategoryLink: defaultCategoryLink,
  defaultProductForm: defaultProductForm,
  defaultProductVariantPicker: defaultProductVariantPicker,
  defaultProductQuantityPicker: defaultProductQuantityPicker,
  defaultProductBuyButton: defaultProductBuyButton,
  defaultProductInfo: defaultProductInfo,
  External: External$3,
  make: NavSDK$SharedComponentsProvider
};
function NavSDK$CustomComponentsLoader(Props) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var componentReferencesInTree = Belt_Array.map(CategoryFinder$Showside.keepMapCategories(config.categories, function (category) {
    var match = category.categoryType;
    if (typeof match === "number" || match.TAG !== /* CustomComponentSection */5) {
      return;
    } else {
      return match._0.component;
    }
  }), function (a) {
    return a;
  });
  var componentsToPreload = Belt_Array.concat(Belt_Array.concat([config.settings.productCardComponent], [config.settings.pdpComponent]), componentReferencesInTree);
  return Belt_Array.map(Belt_Array.keepMap(componentsToPreload, function (a) {
    return a;
  }), function (component) {
    return React.createElement(NavSdk.ComponentLoader, {
      url: component.componentUrl,
      key: Curry._1(CustomComponentId$ApiTypes.toString, component.id) + "-" + component.version
    });
  });
}
NavSDK$CustomComponentsLoader.displayName = "NavSDK.CustomComponentsLoader";
var CustomComponentsLoader = {
  make: NavSDK$CustomComponentsLoader
};
function NavSDK$Provider(Props) {
  var children = Props.children;
  return React.createElement(NavSDK$SharedComponentsProvider, {
    children: null
  }, React.createElement(NavSDK$CustomComponentsLoader, {}), children);
}
NavSDK$Provider.displayName = "NavSDK.Provider";
var Provider = {
  make: NavSDK$Provider
};
export { Loader, transformProps, ProductRenderer, CustomSectionRenderer, CategoryRenderer, SharedComponentsProvider, CustomComponentsLoader, Provider };
/* react Not a pure module */